import { Box } from '@chakra-ui/react'
import { FC } from 'react'
import { StatisticsOverview } from './components/StatisticsOverview'
import { CacheManagementPanel } from './components/CacheManagementPanel'
import { ActiveTasksMonitor } from './components/ActiveTasksMonitor'

/**
 * Cache Management Page
 * Admin page for managing cache (Summary and WordCloud)
 */
export const CacheManagement: FC = () => {
  return (
    <Box
      bgColor="white.50"
      borderRadius={4}
      minH="calc(100vh - 88px)"
      padding="12px 24px"
      w="100%"
    >
      {/* Section 1: Statistics Overview */}
      <StatisticsOverview />

      {/* Section 2: Cache Management Panel */}
      <CacheManagementPanel />

      {/* Section 3: Active Tasks Monitor */}
      <ActiveTasksMonitor />
    </Box>
  )
}
